module.exports = __webpack_public_path__ + "static/media/Leopard World Distribution.bcb0748b.png";